import { graphql, useStaticQuery } from 'gatsby';
import * as React from 'react'; // tslint:disable-line
import { CommunityRequestsProvider as Provider } from '../../components/context/community-requests-context';
import { platformProviderValue } from '@shapeable/ui';

const COMMUNITY_REQUESTS_QUERY = graphql`
query PlatformAllCommunityRequestsQuery {
  platform { allCommunityRequests {
    
      
    
        id name slug typeLabel badge path updated __typename _schema { label pluralLabel }
    
      
      
            openGraph { 
              id title 
              
              image { 
                id url url2x 
                thumbnails { 
                  id bubbleMedium { id url url2x }
                }
                
              } 
            }
          
    
    description { id text }
    followersCount
    followers {
      id name slug path
      openGraph { id image { id url url2x } }
    }
    types {
      
        
      
          id name slug typeLabel badge path updated __typename _schema { label pluralLabel }
      
        
        
              openGraph { 
                id title 
                
                image { 
                  id url url2x 
                  thumbnails { 
                    id bubbleMedium { id url url2x }
                  }
                  
                } 
              }
            
      
    }
  } }
}

`

export const CommunityRequestsProvider: React.FC<any> = ({ children }) => {
  return <Provider value={ platformProviderValue( useStaticQuery(COMMUNITY_REQUESTS_QUERY), 'allCommunityRequests' ) }>{children}</Provider>;
};